import { ReactNode } from "react";

import { Heading } from "@/basic/components";


import styles from "./styles.module.scss";

export interface PageTitleWrapperProps {
  children?: ReactNode;
  title: ReactNode;
}

export const PageTitleWrapper = (props: PageTitleWrapperProps) => {
  const { children, title } = props;

  return (
    <div className={styles["PageTitleWrapper"]}>
      <Heading {...props}>{title}</Heading>
      {children}
    </div>
  );
};
